// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"9c80a09a46fda13f","5405":"99557a0f098516f4","7618":"3d0c2617a0052876","8026":"d7127e3ddd7de4f5"}[chunkId] + ".css";
};